module.exports = __webpack_public_path__ + "img/pjt03.f2a95336.png";